export const C = {
  bg:        "#050505",
  bgRaise:   "#0B0B0C",
  fg:        "#FFFFFF",
  fg2:       "rgba(255,255,255,0.62)",
  fg3:       "rgba(255,255,255,0.38)",
  fg4:       "rgba(255,255,255,0.18)",
  surface:   "rgba(255,255,255,0.035)",
  surface2:  "rgba(255,255,255,0.06)",
  border:    "rgba(255,255,255,0.08)",
  borderHi:  "rgba(255,255,255,0.18)",
  danger:    "rgba(255,90,90,0.85)",
  dangerBg:  "rgba(255,70,70,0.10)",
} as const;

export const mono = 'ui-monospace, "SF Mono", Menlo, monospace';
